import { render, staticRenderFns } from "./WxLayout.vue?vue&type=template&id=b613f936&scoped=true&"
import script from "./WxLayout.vue?vue&type=script&lang=js&"
export * from "./WxLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613f936",
  null
  
)

export default component.exports